const LdapEditMode = {
    none: 0,
    add: 1,
    update: 2
};

const LdapDirectoryType = {

    activeDirectory: 'activedirectory',
    openLDAP: 'openldap',
    customLDAPServer: 'customldapserver'
};

export {
    LdapEditMode,
    LdapDirectoryType
};